import Store, { RootState } from "../../../redux/store";
import * as actions from "./products.actions";
import { createSelector } from "reselect";
import { ProductsState } from "../types/products-state/products-state.interface";

export const getProductsState = (state: RootState) => state.products;

export const getSearchResults = createSelector(
  getProductsState,
  (state: ProductsState) => state.searchResults?.results || []
);

export function search(searchTerm: string) {
  Store.dispatch(actions.search(searchTerm));
}
